import {Article} from '@shopify/hydrogen/storefront-api-types';
import {ReactElement} from 'react';
import type {PartialDeep} from 'type-fest';
import {Image} from '@shopify/hydrogen';

export function ArticleGridItem({
  article,
}: {
  article: PartialDeep<Article> | undefined;
}): ReactElement {
  return (
    <div className="group flex flex-col rounded-[1.2rem] p-10">
      <div className="relative mb-10 aspect-video overflow-hidden rounded-[1.2rem]">
        <Image
          className="h-full scale-100 object-cover object-center duration-300 group-hover:scale-125"
          src={article?.image?.src ?? ''}
          alt="..."
          width={1080}
          height={1080}
        />
      </div>
      <div className="flex flex-col gap-4">
        <div className="text-xl font-light md:text-4xl">{article?.title}</div>
        <div>
          {article && article.excerpt != null && article.excerpt != ''
            ? article.excerpt
            : 'No description'}
        </div>
        <div>
          <a
            href={`/blogs/${article?.blog?.handle}/${article?.handle}`}
            className="rounded-full border border-black px-4 py-2 text-xs uppercase duration-300 hover:bg-black hover:text-white md:text-sm"
            type="button"
          >
            Read more
          </a>
        </div>
      </div>
    </div>
  );
}
